import React, { forwardRef } from 'react';
import { Box, theme } from '@fiverr-private/theme';
import type { ImageProps } from './types';
import { generateSrcSet, getKey, getSource } from './utils';

const Image = forwardRef<HTMLImageElement, ImageProps>(
  ({ src: imageSrc = '', width = '100%', alt, objectFit, ...rest }, ref) => {
    const { src, ...sources } = getSource(imageSrc);
    const isPictureTag = sources && Object.keys(sources).length > 0;

    return isPictureTag ? (
      <Box as="picture">
        {Object.keys(sources)?.map((key) => (
          <Box as="source" key={getKey()} srcSet={generateSrcSet(sources[key].srcSet)} media={theme.breakpoints[key]} />
        ))}
        <Box as="img" alt={alt} ref={ref} objectFit={objectFit} src={src} width={width} {...rest} />
      </Box>
    ) : (
      <Box as="img" alt={alt} ref={ref} objectFit={objectFit} src={src} width={width} {...rest} />
    );
  }
);

Image.displayName = 'Image';

export default Image;
